import { Link2, Search } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import type { Product } from "@/mocks/products";

type ProductSearchProps = {
  query: string;
  notice: string;
  quickProducts: Product[];
  onQueryChange: (value: string) => void;
  onSubmit: () => void;
  onQuickSelect: (product: Product) => void;
};

export function ProductSearch({
  query,
  notice,
  quickProducts,
  onQueryChange,
  onSubmit,
  onQuickSelect,
}: ProductSearchProps): JSX.Element {
  return (
    <Card className="border-0 bg-transparent py-0 shadow-none">
      <CardContent className="p-0">
        <div className="flex flex-nowrap items-end gap-5 max-xl:flex-wrap">
          <div className="relative flex w-[518px] flex-none gap-3 max-lg:w-full">
            <label
              className="absolute -top-[18px] left-3 text-xs font-medium text-white"
              htmlFor="product-query"
            >
              Product
            </label>
            <div className="relative min-w-0 flex-1">
              <Link2
                aria-hidden="true"
                className="absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-[#a7b1c3]"
              />
              <Input
                className="h-11 rounded-lg border-[#1d2b43] bg-[#08111f] pl-11 text-[15px] font-medium text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.04)] placeholder:text-[#6f7d94]"
                id="product-query"
                onChange={(event) => onQueryChange(event.target.value)}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    onSubmit();
                  }
                }}
                placeholder="https://shopee.vn/product/882001/136790013"
                value={query}
              />
            </div>
            <Button
              className="h-11 w-24 rounded-lg bg-[#ff3d16] text-base font-extrabold text-white shadow-[0_12px_35px_rgba(255,61,22,0.28)] hover:bg-[#ff4a25]"
              onClick={onSubmit}
              type="button"
            >
              <Search className="h-4 w-4" />
              Search
            </Button>
          </div>

          <div
            aria-label="Quick products"
            className="grid min-w-0 flex-1 grid-cols-[138px_164px_minmax(0,1fr)] gap-3 max-lg:grid-cols-1"
          >
            {quickProducts.map((product) => (
              <Button
                className="h-11 w-full justify-center overflow-hidden rounded-lg border-[#1d2b43] bg-[#08111f] px-2.5 text-[13px] font-extrabold text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.04)] hover:bg-[#0b182a]"
                key={product.productKey}
                onClick={() => onQuickSelect(product)}
                type="button"
                variant="outline"
              >
                <span className="truncate">{product.productName.replace(" - Midnight", "")}</span>
              </Button>
            ))}
          </div>
        </div>
        <p className="sr-only" role="status">
          {notice}
        </p>
      </CardContent>
    </Card>
  );
}
